import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/review-rule-sets',
    component: loadableWithRetry(() => import('./ReviewRuleSets')),
    name: 'reviewRuleSets',
    permission: 'reviewRuleSets_route',
    accessRedirectTo: '/dashboard',
    exact: true,
  },
  {
    path: '/review-rule-sets/:id',
    name: 'singleReviewRuleSet',
    component: loadableWithRetry(() => import('./SingleReviewRuleSet')),
    permission: 'reviewRuleSets_route',
    accessRedirectTo: '/dashboard',
    exact: true,
  },
  {
    path: '/review-rule-sets/:id/new-rule',
    name: 'createReviewRule',
    component: loadableWithRetry(() => import('./CreateReviewRule')),
    permission: 'manageReviewRuleSets_route',
    accessRedirectTo: '/dashboard',
    exact: true,
  },
  {
    path: '/review-rule-sets/:id/edit-rule/:ruleName',
    name: 'editReviewRule',
    component: loadableWithRetry(() => import('./EditReviewRule')),
    permission: 'manageReviewRuleSets_route',
    accessRedirectTo: '/dashboard',
    exact: true,
  },
]

export default routes
